const rtf = new Intl.RelativeTimeFormat('pt-BR', { numeric: 'auto' });
const UNITS: [Intl.RelativeTimeFormatUnit, number][] = [
  ['year', 31_536_000],
  ['month', 2_592_000],
  ['week', 604_800],
  ['day', 86_400],
  ['hour', 3600],
  ['minute', 60],
];

export function timeAgo(iso?: string | null): string {
  if (!iso) return '—';
  const sec = (new Date(iso).getTime() - Date.now()) / 1000;
  for (const [unit, size] of UNITS) if (Math.abs(sec) >= size) return rtf.format(Math.round(sec / size), unit);
  return 'agora';
}

export const dateTime = (iso?: string | null) =>
  iso ? new Date(iso).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' }) : '—';

/** Datas sem hora (prazo) chegam como YYYY-MM-DD: formata sem converter fuso. */
export function shortDate(d?: string | null): string {
  if (!d) return '—';
  const [y, m, day] = d.slice(0, 10).split('-');
  return `${day}/${m}/${y}`;
}

export function dueState(d?: string | null, status?: string): 'overdue' | 'soon' | 'ok' | null {
  if (!d || status === 'done' || status === 'canceled') return null;
  const today = new Date().toISOString().slice(0, 10);
  if (d < today) return 'overdue';
  const soon = new Date(Date.now() + 3 * 86_400_000).toISOString().slice(0, 10);
  return d <= soon ? 'soon' : 'ok';
}

export const ACTION_LABELS: Record<string, string> = {
  'task.created': 'criou a tarefa',
  'task.updated': 'editou',
  'task.priority_changed': 'mudou a prioridade',
  'task.status_changed': 'mudou o status',
  'task.moved': 'reordenou no board',
  'task.labels_changed': 'alterou etiquetas',
  'task.relation_added': 'vinculou tarefa',
  'task.relation_removed': 'removeu vínculo',
  'task.comment_added': 'comentou',
  'task.blocker_reported': 'registrou bloqueio',
  'task.blocker_resolved': 'resolveu bloqueio',
  'task.validation_recorded': 'registrou validação',
  'task.archived': 'excluiu a tarefa',
  'task.board_archived': 'arquivou o card',
  'task.board_unarchived': 'desarquivou o card',
  'task.time_logged': 'apontou tempo',
  'task.worklog_deleted': 'removeu apontamento',
  'task.timer_started': 'iniciou o cronômetro',
  'task.timer_canceled': 'descartou o cronômetro',
  'execution.started': 'iniciou execução',
  'execution.finished': 'encerrou execução',
  'project.created': 'criou o projeto',
  'project.updated': 'editou o projeto',
  'label.created': 'criou etiqueta',
  'label.updated': 'editou etiqueta',
  'label.deleted': 'excluiu etiqueta',
  'release.created': 'criou a versão',
  'release.updated': 'editou a versão',
  'release.stage_changed': 'mudou a etapa da versão',
  'release.canceled': 'cancelou a versão',
  'release.published': 'publicou a versão',
  'sprint.created': 'criou a sprint',
  'sprint.updated': 'editou a sprint',
  'sprint.started': 'iniciou a sprint',
  'sprint.closed': 'encerrou a sprint',
  'sprint.deleted': 'excluiu a sprint',
  'document.created': 'criou o documento',
  'document.updated': 'editou o documento',
  'document.deleted': 'excluiu o documento',
  'board.updated': 'configurou o board',
  'board.reset': 'restaurou o board',
  'agent.created': 'criou agente',
  'agent.updated': 'editou agente',
  'agent.token_rotated': 'gerou novo token de agente',
  'user.created': 'criou usuário',
  'user.updated': 'editou usuário',
  'user.password_changed': 'trocou a senha',
  'log.note': 'anotou',
  'log.progress': 'registrou progresso',
  'log.discovery': 'registrou descoberta',
  'log.decision': 'registrou decisão',
  'integration.error': 'falha de integração',
  'integration.request_failed': 'requisição recusada',
};

export const FIELD_LABELS: Record<string, string> = {
  title: 'título',
  description: 'descrição',
  type: 'tipo',
  priority: 'prioridade',
  status: 'status',
  module: 'módulo',
  assignee: 'responsável',
  dueDate: 'prazo',
  labels: 'etiquetas',
  acceptanceCriteria: 'critérios de aceite',
  checklist: 'checklist',
  refs: 'referências',
  implementationSummary: 'resumo da implementação',
  testSummary: 'resumo dos testes',
  pendingNotes: 'pendências',
  relatedProjectKeys: 'projetos relacionados',
  parentKey: 'tarefa-mãe',
  source: 'origem',
  storyKey: 'história',
  estimateMinutes: 'estimativa',
  content: 'conteúdo',
  parentId: 'página-pai',
};
